<template>
    <div class="cap-selector-group">
        <CapSelector v-for="(selector, index) in selectors" :key="index" ref="selectors" :title="selector.title"
            :items="selector.items" v-model="localForm[selector.field]" :placeholder="selector.placeholder || '请选择'"
            :disabled="selector.disabled || false" :active="activeIndex === index" @completed="openNext(index)"
            @input="value => updateField(selector.field, value)" @click="setActiveIndex(index)" />
    </div>
</template>

<script>
import CapSelector from "./CapSelector.vue"

export default {
    name: "CapSelectorGroup",
    components: { CapSelector },
    props: {
        selectors: { type: Array, required: true },
        value: { type: Object, default: () => ({}) },
        autoScroll: { type: Boolean, default: true }
    },
    data() {
        return {
            localForm: { ...this.value },
            activeIndex: 0, // 当前展开选择器
            _updating: false,
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newVal) {
                // 更新字段，但不替换整个对象
                for (let key in newVal) {
                    this.$set(this.localForm, key, newVal[key])
                }
            }
        },
    },
    methods: {
        updateField(field, value) {
            // 保持 localForm 的对象引用不变
            this.$set(this.localForm, field, value)
            console.log(field,value,66)
            // 触发 v-model input 事件，更新父组件绑定的 zcForm
            this.$emit('input', this.localForm)
        },
        setActiveIndex(index) {
            this.activeIndex = index
        },
        openNext(index) {
            this.activeIndex = index + 1
            if (index < this.selectors.length - 1) {
                if (this.autoScroll) this.scrollToIndex(this.activeIndex)
            }
        },
        scrollToIndex(index) {
            const el = this.$refs.selectors[index]?.$el
            if (!el) return
            requestAnimationFrame(() => {
                el.scrollIntoView({ behavior: "smooth", block: "center" })
            })
        }
    }
}
</script>

<style scoped>
.cap-selector-group {
    display: flex;
    flex-direction: column;
}
</style>
